"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Constants = function () {
  function Constants() {}

  Constants.canvasClass = "tsparticles-canvas-el";
  Constants.randomColorValue = "random";
  Constants.midColorValue = "mid";
  Constants.touchEndEvent = "touchend";
  Constants.mouseUpEvent = "mouseup";
  Constants.mouseMoveEvent = "mousemove";
  Constants.touchStartEvent = "touchstart";
  Constants.touchMoveEvent = "touchmove";
  Constants.mouseLeaveEvent = "mouseleave";
  Constants.touchCancelEvent = "touchcancel";
  Constants.resizeEvent = "resize";
  Constants.visibilityChangeEvent = "visibilitychange";
  Constants.noPolygonDataLoaded = "No polygon data loaded.";
  Constants.noPolygonFound = "No polygon found, you need to specify SVG url in config.";
  return Constants;
}();

exports.Constants = Constants;